import { DEFAULT_PALETTE_NAME } from 'src/modules/homeownerApp/constants';

import type { DesignerProduct } from '../../types';

/**
 * Given a flat list of colors, group the colors by palette and produce a
 * list of palettes with the associated colors
 *
 * @param colors paint colors returned from `AiAvailableConfigurationsQuery`
 */
export const buildPalettes = <T extends DesignerProduct>(colors: T[]) =>
  Object.entries(
    colors.reduce(
      (palettes, color) =>
        color.palettes.reduce(
          (innerPalettes, palette) => ({
            ...innerPalettes,
            [palette]: [...(innerPalettes[palette] || []), color],
          }),
          palettes,
        ),
      {} as Record<string, T[]>,
    ),
  )
    .map(([name, paletteColors]) => ({
      name,
      colors: paletteColors,
    }))
    .sort(palette =>
      DEFAULT_PALETTE_NAME && palette.name.includes(DEFAULT_PALETTE_NAME)
        ? -1
        : 0,
    );
